import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useWindowSize } from 'usehooks-ts';

import Constants from '../config.js';


/**
 * MobileTabBar — standard iOS/Android bottom tab bar.
 *
 * Replaces the old bottom-right floating hamburger (.fab-menu). Three tabs:
 *   - Tokens  -> /wallet          (home / token picker)
 *   - Settings -> /wallet/settings
 *   - More     -> opens the full menu (MenuPanelOptions full-screen)
 *
 * The full menu remains available as a fallback and for the less-important
 * links that don't deserve a permanent tab.
 *
 * Props:
 *   - onOpenMenu: () => void  (opens the full mobile menu)
 *
 * Renders null on desktop and on non-wallet (app-launch) routes.
 */
const TABS = [
	{ key: 'home',     label: 'Tokens',   path: '/wallet',          icon: 'fa-wallet' },
	{ key: 'settings', label: 'Settings', path: '/wallet/settings', icon: 'fa-cog' },
	{ key: 'more',     label: 'More',     path: null,               icon: 'fa-bars' },
];

const MobileTabBar = ({ onOpenMenu }) => {
	const location = useLocation();
	const history = useHistory();
	const { width: windowWidth = 0 } = useWindowSize();
	const isMobile = windowWidth < Constants.WINDOW_WIDTH_THRESHOLD_PX;

	if (!isMobile) return null;

	const p = location.pathname;
	const isWalletRoute =
		p === '/' || p === '/home' || p === '/wallet' || p.startsWith('/wallet/');
	if (!isWalletRoute) return null;

	const isActive = (tab) => {
		if (tab.key === 'home') {
			return p === '/' || p === '/home' || p === '/wallet';
		}
		if (tab.key === 'settings') {
			return p === '/wallet/settings';
		}
		return false;
	};

	const onClick = (tab) => {
		if (tab.key === 'more') {
			if (onOpenMenu) onOpenMenu();
			return;
		}
		history.push(tab.path);
	};

	return (
		<nav className="mobileTabBar">
			{TABS.map(tab => (
				<button
					key={tab.key}
					type="button"
					className={'mobileTabBarItem' + (isActive(tab) ? ' active' : '')}
					onClick={() => onClick(tab)}
				>
					<i className={'fas ' + tab.icon} />
					<span>{tab.label}</span>
				</button>
			))}
		</nav>
	);
};

export default MobileTabBar;
